/*
 * @Author: zys22 226208335@qq.com
 * @Date: 2025-10-10 09:59:43
 * @LastEditors: zys22 226208335@qq.com
 * @LastEditTime: 2026-10-14 09:44:51
 * @FilePath: /frasergen-weixin-web/src/utils/http.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'
import {getToken,clearToken} from './token'
import { history } from './history'



const http = axios.create({
  // baseURL: 'http://192.168.2.189:10086/',
  //刚打开项目环境 http://114.115.134.103:10086/
  baseURL: 'https://wechat.frasergen.com/backend/',
  timeout: 5000
})
// 添加请求拦截器
http.interceptors.request.use((config)=> {
  const token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
    config.headers.HomePage = `${history.location.pathname.split('/')[1]}`
  }
  return config
}, (error)=> {
  return Promise.reject(error)
})

// 添加响应拦截器
http.interceptors.response.use((response)=> {
  // 2xx 范围内的状态码都会触发该函数。
  // 对响应数据做点什么
  return response.data
}, (error)=> {
  // 超出 2xx 范围的状态码都会触发该函数。
  // 对响应错误做点什么
  if (error.response?.status === 401) {
    // 删除token
    clearToken()
    // 跳转到登录页
    // history.push('/login')
  }
  return Promise.reject(error)
})

export { http }